import { render, staticRenderFns } from "./User_behavior.vue?vue&type=template&id=303f864e&"
import script from "./User_behavior.vue?vue&type=script&lang=js&"
export * from "./User_behavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports